import { render, staticRenderFns } from "./purchase_request.vue?vue&type=template&id=7c8ea543&"
import script from "./purchase_request.vue?vue&type=script&lang=js&"
export * from "./purchase_request.vue?vue&type=script&lang=js&"
import style0 from "./purchase_request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports